module.exports = __webpack_public_path__ + "DINNextLTPro-Heavy.ttf?bd2d92f34fa162a1b5707cc126fcc357";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-Heavy.ttf
// module id = 1411
// module chunks = 0